import { useIntl } from 'react-intl';

export const usePreset = (preset: string) => {
  const intl = useIntl();
  const buttonText = intl.formatMessage({
    id: 'UseGetPreset.addFiltersButton',
    defaultMessage: 'Add Filters',
    description: 'Button text for adding filters',
  });

  const ctaText = intl.formatMessage({
    id: 'UseGetPreset.addCta',
    defaultMessage: 'Add',
    description: 'CTA text for add action',
  });
  const addFilters = {
    buttonText,
    buttonVariant: 'action' as const,
    ctaText,
  };

  const addFiltersButton = {
    buttonText,
    buttonVariant: 'primary' as const,
    ctaText,
    buttonIcon: 'filter' as const,
    buttonSize: 's' as const,
  };

  const editCharts = {
    buttonText: intl.formatMessage({
      id: 'UseGetPreset.editChartsButton',
      defaultMessage: 'Edit Charts',
      description: 'Button text for editing charts',
    }),
    buttonVariant: 'secondary' as const,
    ctaText: intl.formatMessage({
      id: 'UseGetPreset.applyChangesCta',
      defaultMessage: 'Apply Changes',
      description: 'CTA text for applying changes',
    }),
  };

  switch (preset) {
    case 'add-filters-button':
      return addFiltersButton;
    case 'add-filters':
      return addFilters;
    case 'edit-charts':
      return editCharts;
    case 'default':
    default:
      return addFilters;
  }
};
